export default __webpack_public_path__ + "static/itAllAddsUpCard1-8623ec910fbf43e6eaaf85d27c936b0d.png";